// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"2401f57f","405":"79dcfb95","787":"cda612ba","943":"66b8ed65"}[chunkId] + ".chunk.js";
};